import { apiMoney } from '@ms/utils-es/math'
import { getUofId, isBetBuilderSelection } from '@ms/stores/betslip/func'

/**
 * 获取下单时的 selections 值
 * @param  {Array}  list [description]
 * @return {[type]}      [description]
 */
export const getPlaceSelections = (selectionList = [], orderType, bankerMap, singleStakeMap, isAllMultiplesMode) => {
  let list = selectionList
  if (orderType === 'single' && !isAllMultiplesMode) {
    if (Object.keys(singleStakeMap).length > 0) {
      // selection single
      list = selectionList.filter((x) => singleStakeMap[x.id])
    }
  }

  return list.map((selection) => {
    const { eventId, outcomeInfo } = selection
    const res = {
      eventId,
      odds: outcomeInfo.odds, // 赔率
      probability: outcomeInfo.probability
    }

    const isBanker = bankerMap && !!bankerMap[selection.id] // 是否是banker，只对于Systembet有效
    if (isBetBuilderSelection(selection)) {
      const subSelections = selection.betBuilderSelections.map((x) => {
        return {
          eventId,
          id: getUofId(x),
          odds: x.outcomeInfo.odds, // 赔率
          probability: x.outcomeInfo.probability
        }
      })
      Object.assign(res, {
        customizedMarketType: 1, // 自研market的类型, 1 代表bet builder
        subSelections,
        banker: isBanker
      })
    } else {
      Object.assign(res, {
        id: getUofId(selection),
        banker: isBanker
      })
    }

    return res
  })
}

export const getPlaceBets = (orderType, { isAllMultiplesMode, magicNumber, singleStakeMap, standardMultipleStake, systemStakeList, selectionList = [] }) => {
  switch (orderType) {
    case 'single':
      if (isAllMultiplesMode) {
        // 多选项每个选项一注相同Stake的Single Bet, 即 mutiple singles
        return [
          {
            selectedSystems: [1],
            stake: {
              value: apiMoney(systemStakeList[0].stake)
            }
          }
        ]
      } else {
        // selection single， 由于是 orderType 是 single 类型，所以 selectionIndex 是从 0 开始的
        const { stake, count } = standardMultipleStake
        if (count === 1 && stake) {
          // return stake || singleStake
          return [
            {
              selectedSystems: [1],
              selectionRefs: selectionList
                .filter((x) => singleStakeMap[x.id])
                .map((_x, index) => ({
                  selectionIndex: index
                })),
              stake: {
                value: apiMoney(stake)
              }
            }
          ]
        }
        return selectionList
          .filter((x) => singleStakeMap[x.id])
          .map((x, index) => ({
            selectedSystems: [1],
            selectionRefs: [
              {
                selectionIndex: index // 选项下标，只有在SingleBet并且选项的stake不同的时候有用
              }
            ],
            stake: {
              value: apiMoney(singleStakeMap[x.id].stake)
            }
          }))
      }
    case 'multiple': {
      if (isAllMultiplesMode) {
        // 在 all multiples 模式下，只有最高的 multipleItem stake 才是 multiple，其他都是 system
        return systemStakeList.map((x) => ({
          selectedSystems: [+x.count], // 选项里面选几个串起来
          stake: {
            value: apiMoney(x.stake)
          }
        }))
      } else {
        return [
          {
            stake: {
              value: apiMoney(standardMultipleStake.stake)
            }
          }
        ]
      }
    }
    case 'flexible':
    case 'supple': {
      return [
        {
          magicNumber,
          selectedSystems: [standardMultipleStake.count], // 选项里面选几个串起来
          stake: {
            value: apiMoney(standardMultipleStake.stake)
          }
        }
      ]
    }
    case 'system': {
      if (isAllMultiplesMode) {
        return systemStakeList.map((x) => ({
          selectedSystems: [+x.count], // 选项里面选几个串起来
          stake: {
            value: apiMoney(x.stake)
          }
        }))
      } else {
        // standard system: 有 multiple + single 形成
        return [
          // standard multiple
          {
            selectedSystems: [+standardMultipleStake.count], // 选项里面选几个串起来
            stake: {
              value: apiMoney(standardMultipleStake.stake)
            }
          },
          // standard selections single. 部分 selection 有 stake, 所以索引位置不一定从 0 开始
          ...Object.values(singleStakeMap).map((x) => ({
            selectionRefs: [
              {
                selectionIndex: selectionList.findIndex((selection) => selection.id === x.id)
              }
            ],
            selectedSystems: [1],
            stake: {
              value: apiMoney(x.stake)
            }
          }))
        ]
      }
    }
    default:
    // no default
  }
}
